import { useState, type ReactNode } from 'react'
import { ChevronDown } from 'lucide-react'
import { citeste, scrie } from './date'

/**
 * O sectiune de pe Acasa, care se poate restrange (Madalin, 13.10.2026: personalizarea e
 * „restrangi o sectiune si alegi cifrele", fara casete de tras). Starea ramane in browser, pe om.
 */
export function Sectiune({
  id,
  utilizator,
  titlu,
  sub,
  actiune,
  caseta = true,
  children,
}: {
  id: string
  utilizator: number | undefined
  titlu: string
  sub?: ReactNode
  /** In dreapta capului — un link, un buton mic. */
  actiune?: ReactNode
  /** Fara caseta in jur (cifrele au casete proprii). */
  caseta?: boolean
  children: ReactNode
}) {
  const cheie = `b4l.acasa.restranse.${utilizator ?? 0}`
  const [restransa, setRestransa] = useState(() => citeste<string[]>(cheie, []).includes(id))
  const comuta = () => {
    const toate = new Set(citeste<string[]>(cheie, []))
    if (restransa) toate.delete(id)
    else toate.add(id)
    scrie(cheie, [...toate])
    setRestransa(!restransa)
  }
  const idTitlu = `acasa-${id}`
  return (
    <section
      aria-labelledby={idTitlu}
      className={
        caseta
          ? 'grid gap-2 rounded-caseta border border-b4l-border bg-b4l-surface p-3 sm:p-4'
          : 'grid gap-2'
      }
    >
      <div className="flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={comuta}
          aria-expanded={!restransa}
          className="flex min-w-0 items-center gap-1.5 rounded-md text-left hover:text-b4l-text"
        >
          <ChevronDown
            size={15}
            aria-hidden="true"
            className={`shrink-0 text-b4l-text-dim transition-transform ${restransa ? '-rotate-90' : ''}`}
          />
          <h2 id={idTitlu} className="text-sectiune text-b4l-text">
            {titlu}
          </h2>
          {sub && <span className="truncate text-mic text-b4l-text-dim">{sub}</span>}
        </button>
        {!restransa && actiune}
      </div>
      {!restransa && children}
    </section>
  )
}
